import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { testWindow } from '../Wrappers/MainWindow';
import Frame from '../Wrappers/Frame';
import * as offerActions from '../../redux/offers';
import { Row, Col } from '../Grid';
import OffersMenu from './OffersMenu';
import OfferList from './Partials/OfferList';
import OfferPeriods from './Partials/OfferPeriods';
import './Offer.css';

interface Props {
  type: OfferListType;
  period?: string;
  changeType: Function;
}

const Container = styled.div`
  min-width: 750px;
  max-width: 750px;
`;

function Offers(props: Props) {
  document.title = `${props.type.capitalize()} Offers • Neoncoat Brands Tool`;
  props.changeType(props.type);
  const { type, period } = props;

  return (
    <Row>
      <Container>
        <Frame title={`Offers`} fullHeight={true}>
          <OffersMenu type={props.type} />
          {props.type === 'past' && !props.period ? (
            <OfferPeriods />
          ) : (
            <div style={{ height: '100%', width: '100%', overflow: 'auto' }}>
              <OfferList type={type} period={period} />
            </div>
          )}
        </Frame>
      </Container>
    </Row>
  );
}

export default connect(null, offerActions)(testWindow(Offers, 'offers'));
